import styled from 'styled-components';

const Text = styled.div`
  font-weight: normal;
  // border: 1px solid #ccc;
  width: 100%;
  font-size: 0.86em;
  padding: 5px;
  background-color: '#fff';
  font-family: inherit;
  width: 100%;
  min-height: 32px;
  .summary-content & {
    padding: 0px;
  }
  .summary-content .expenses & {
    margin-left: 30px;
  }
`;

export default Text;



// WEBPACK FOOTER //
// ./app/components/Text/index.js